import { motion } from "framer-motion"
import { ChevronDown } from "lucide-react"
import { useEffect, useState } from "react"

export function LandingScrollIndicator() {
  const [opacity, setOpacity] = useState(1)

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY || window.pageYOffset
      // Fade out immediately when page starts to scroll
      if (scrollY <= 0) {
        setOpacity(1)
      } else {
        setOpacity(0)
      }
    }

    handleScroll()
    window.addEventListener("scroll", handleScroll, { passive: true })
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  // Helper: smooth scroll to bracky section (same as nav behavior)
  const scrollToBracky = () => {
    const el = document.getElementById("bracky")
    if (!el) return

    // Let CSS scroll-margin handle the fixed header offset
    el.scrollIntoView({ behavior: "smooth" })

    // Reflect the new position in the address bar without triggering a jump
    if (window.history.replaceState) {
      window.history.replaceState(null, "", `${window.location.pathname}#bracky`)
    } else {
      // Fallback
      window.location.hash = "#bracky"
    }
  }

  return (
    <div
      className={`fixed left-0 right-0 flex flex-col items-center scale-90 z-40 bottom-[.7rem] sm:bottom-6 md:bottom-8 lg:bottom-10 xl:bottom-10 transition-opacity duration-300 ${opacity === 0 ? "opacity-0" : "opacity-100"}`}
    >
      {/* Bobbing helper text shown on tall screens */}
      <motion.div
        className="hidden tall:block text-white text-base font-medium tracking-wide mb-[-.1rem] text-center whitespace-nowrap"
        animate={{ y: [0, 2, 0], opacity: [0.5, 1, 0.5] }}
        transition={{ duration: 1.62, repeat: Number.POSITIVE_INFINITY, ease: "easeInOut" }}
      >
        Scroll to learn more
      </motion.div>

      {/* Clickable background shape */}
      <button
        type="button"
        onClick={scrollToBracky}
        className="relative group cursor-pointer"
        aria-label="Scroll to @bracky features"
      >
        {/* Chevron icons */}
        <div className="relative pointer-events-none">
          <motion.div
            animate={{ y: [0, 2, 0], opacity: [0.5, 1, 0.5] }} // Reduced movement in half and opacity max at 0.75
            transition={{ duration: 1.62, repeat: Number.POSITIVE_INFINITY, ease: "easeInOut" }}
          >
            <ChevronDown className="w-4.5 h-4.5 text-white" />
          </motion.div>
          <motion.div
            animate={{ y: [0, 2, 0], opacity: [0.5, 1, 0.5] }} // Reduced movement in half and opacity max at 0.75
            transition={{ duration: 1.62, repeat: Number.POSITIVE_INFINITY, ease: "easeInOut", delay: 0.1 }}
            className="-mt-4"
          >
            <ChevronDown className="w-4.5 h-4.5 text-white" />
          </motion.div>
        </div>
      </button>
    </div>
  )
}
